import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';
import { DirectoryEntryEditInfo } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-editing/directory-editing-behaviour.state';

@Pipe({
   name: 'directoryInfoLastEditingUser',
})
export class DirectoryInfoLastEditingUserPipe implements PipeTransform {
   transform(info: DirectoryEntryEditInfo): string {
      if (!_.isNil(info?.updatedEntry?.usrnam)) {
         return info?.updatedEntry?.usrnam;
      }
      if (!_.isNil(info?.editedEntry?.usrnam)) {
         return info?.editedEntry?.usrnam;
      }
      if (!_.isNil(info?.originalEntry?.usrnam)) {
         return info?.originalEntry?.usrnam;
      }
      return null;
   }
}
